import { Injectable } from '@angular/core';
import { parseJWT } from '@approot/utilities';
import { PhoenixEventBusService } from './phoenix/phoenix-event-bus.service';
import { AuthService } from './auth/auth.service';

export interface TimingMeta {
  timeIn: number;
  timeOut: number;
  timeDiff: number;
  lambdaName: string;
  log: string;
}

@Injectable({
  providedIn: 'root'
})
export class TimingService {
  constructor(
    private authService: AuthService,
    private phxBus: PhoenixEventBusService
  ) {}

  public async logTimings(meta: TimingMeta, startTime: number) {
    if (!meta) {
      console.warn('No meta data to log');
      return;
    }
    const endTime = Date.now();
    const roundTripTime = endTime - startTime;
    const jwt = parseJWT(await this.authService.getJwtToken());
    const email = jwt.email;
    const group = jwt['cognito:groups'][0];
    const emailDomain = email.split('@')[1];
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let hydraTimeIn: number;
    let hydraTimeOut: number;
    let hydraTimeDiff: number;
    let flightTime: number;
    let lambdaName: string;
    let hydraLog: string;
    if (meta) {
      hydraTimeIn = Math.round(meta.timeIn * 1000);
      hydraTimeOut = Math.round(meta.timeOut * 1000);
      hydraTimeDiff = Math.round(meta.timeDiff * 1000);
      flightTime = Math.round(roundTripTime - hydraTimeDiff);
      lambdaName = meta.lambdaName;
      hydraLog = meta.log;
    }

    this.phxBus.addEvent({
      type: 'hydra',
      category: 'requestTiming',
      startTime,
      endTime,
      roundTripTime,
      flightTime,
      timezone,
      hydraTimeIn,
      hydraTimeOut,
      hydraTimeDiff,
      hydraLog,
      lambdaName,
      emailDomain,
      group
    });
  }
}
